import React, { useEffect, FC } from 'react';
import Grid from '@mui/material/Grid';
import { SCUIHomeDashboardCard } from '../../../atomic/molecules';
import { SCUIContent } from '../../../atomic/organisms';
import { PageUrl } from '../../../types/enums';
import { useTranslation } from 'react-i18next';

export const Dashboard: FC<any> = (props: any) => {
    const { t } = useTranslation();

    useEffect(() => {
        const hash = props?.history?.location?.hash;
        const el = hash && document.getElementById(hash.substr(1));
        if (el) {
            el.scrollIntoView({ behavior: 'smooth' });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props?.history?.location?.hash]);

    return (
        <div className="home">
            <SCUIContent headerName={' '}>
                <Grid container spacing={3}>
                    <Grid size={{ lg: 3, sm: 6, xl: 3, xs: 12 }} className="testYayin">
                        <SCUIHomeDashboardCard
                            headText={t('dashboard.comments')}
                            context={''}
                            componentName={PageUrl.commentList.url}
                        />
                    </Grid>

                    <Grid size={{ xl: 3, lg: 3, sm: 6, xs: 12 }} className="testYayin">
                        <SCUIHomeDashboardCard
                            headText={t('dashboard.menuManagement')}
                            context={''}
                            componentName={PageUrl.menuManagement.url}
                        />
                    </Grid>

                    <Grid size={{ xl: 3, lg: 3, sm: 6, xs: 12 }} className="testYayin">
                        <SCUIHomeDashboardCard
                            headText={t('dashboard.authorizationManagement')}
                            context={''}
                            componentName={PageUrl.authorizationRuleManagement.url}
                        />
                    </Grid>

                    <Grid size={{ xl: 3, lg: 3, sm: 6, xs: 12 }} className="testYayin">
                        <SCUIHomeDashboardCard
                            headText={t('dashboard.tagManagement')}
                            context={''}
                            componentName={PageUrl.commentTicket.url}
                        />
                    </Grid>
                    <Grid size={{ xl: 3, lg: 3, sm: 6, xs: 12 }} className="testYayin">
                        <SCUIHomeDashboardCard
                            headText={t('dashboard.commentRejectReasonManagement')}
                            context={''}
                            componentName={PageUrl.commentRejectReason.url}
                        />
                    </Grid>
                    <Grid size={{ xl: 3, lg: 3, sm: 6, xs: 12 }}>
                        <SCUIHomeDashboardCard
                            headText={'Store LcWaikiki'}
                            context={''}
                            componentName={PageUrl.storeLcWaikiki.url}
                        />
                    </Grid>
                    <Grid size={{ xl: 3, lg: 3, sm: 6, xs: 12 }}>
                        <SCUIHomeDashboardCard
                            headText={'Store LcWaikiki V2'}
                            context={''}
                            componentName={PageUrl.storeLcWaikikiV2.url}
                        />
                    </Grid>
                    <Grid size={{ xl: 3, lg: 3, sm: 6, xs: 12 }}>
                        <SCUIHomeDashboardCard
                            headText={t('dashboard.cacheManagement')}
                            context={''}
                            componentName={PageUrl.cacheManagement.url}
                        />
                    </Grid>
                    <Grid size={{ xl: 3, lg: 3, sm: 6, xs: 12 }}>
                        <SCUIHomeDashboardCard
                            headText={t('dashboard.paymentLog')}
                            context={''}
                            componentName={PageUrl.paymentLogs.url}
                        />
                    </Grid>
                    <Grid size={{ xl: 3, lg: 3, sm: 6, xs: 12 }}>
                        <SCUIHomeDashboardCard
                            headText={t('dashboard.cacheTeam')}
                            context={''}
                            componentName={PageUrl.cacheTeam.url}
                        />
                    </Grid>

                    <Grid size={{ xl: 3, lg: 3, sm: 6, xs: 12 }}>
                        <SCUIHomeDashboardCard
                            headText={'Design Collective'}
                            context={''}
                            componentName={PageUrl.designCollective.url}
                        />
                    </Grid>
                    <Grid size={{ xl: 3, lg: 3, sm: 6, xs: 12 }}>
                        <SCUIHomeDashboardCard
                            headText={t('dashboard.mobilePanelConfiguration')}
                            context={''}
                            componentName={PageUrl.mpConfig.url}
                        />
                    </Grid>
                    <Grid size={{ xl: 3, lg: 3, sm: 6, xs: 12 }}>
                        <SCUIHomeDashboardCard
                            headText={t('dashboard.mobileApp')}
                            context={''}
                            componentName={PageUrl.mpApplicationHandler.url}
                        />
                    </Grid>
                    <Grid size={{ xl: 3, lg: 3, sm: 6, xs: 12 }}>
                        <SCUIHomeDashboardCard
                            headText={t('dashboard.listUserRoles')}
                            context={''}
                            componentName={PageUrl.listUserRoles.url}
                        />
                    </Grid>
                    <Grid size={{ xl: 3, lg: 3, sm: 6, xs: 12 }}>
                        <SCUIHomeDashboardCard
                            headText={t('dashboard.storePickup')}
                            context={''}
                            componentName={PageUrl.storePickUp.url}
                        />
                    </Grid>
                    <Grid size={{ xl: 3, lg: 3, sm: 6, xs: 12 }}>
                        <SCUIHomeDashboardCard
                            headText={t('dashboard.storeList')}
                            context={''}
                            componentName={PageUrl.storeList.url}
                        />
                    </Grid>
                    <Grid size={{ xl: 3, lg: 3, sm: 6, xs: 12 }}>
                        <SCUIHomeDashboardCard
                            headText={'Transfer Cargo Data'}
                            context={''}
                            componentName={PageUrl.transferCargoData.url}
                        />
                    </Grid>
                    <Grid size={{ xl: 3, lg: 3, sm: 6, xs: 12 }}>
                        <SCUIHomeDashboardCard
                            headText={'Service Managment'}
                            context={''}
                            componentName={PageUrl.serviceManagment.url}
                        />
                    </Grid>

                    <Grid size={{ xl: 3, lg: 3, sm: 6, xs: 12 }}>
                        <SCUIHomeDashboardCard
                            headText={t('dashboard.shippingCompanyRequest')}
                            context={''}
                            componentName={PageUrl.shippingCompanyRequest.url}
                        />
                    </Grid>
                    <Grid size={{ xl: 3, lg: 3, sm: 6, xs: 12 }}>
                        <SCUIHomeDashboardCard
                            headText={t('customerInformation.lcwMoney')}
                            context={''}
                            componentName={PageUrl.lcwMoney.url}
                        />
                    </Grid>
                    <Grid size={{ xl: 3, lg: 3, sm: 6, xs: 12 }}>
                        <SCUIHomeDashboardCard
                            headText={'Shipping Performance'}
                            context={''}
                            componentName={PageUrl.shippingPerformance.url}
                        />
                    </Grid>
                    <Grid size={{ xl: 3, lg: 3, sm: 6, xs: 12 }}>
                        <SCUIHomeDashboardCard
                            headText={'Search Service'}
                            context={''}
                            componentName={PageUrl.searchService.url}
                        />
                    </Grid>
                    <Grid size={{ xl: 3, lg: 3, sm: 6, xs: 12 }}>
                        <SCUIHomeDashboardCard
                            headText={'Menu Management All'}
                            context={''}
                            componentName={PageUrl.menuManagementAll.url}
                        />
                    </Grid>
                    <Grid size={{ xl: 3, lg: 3, sm: 6, xs: 12 }}>
                        <SCUIHomeDashboardCard
                            headText={t('dashboard.billingServiceLog')}
                            context={''}
                            componentName={PageUrl.billingService.url}
                        />
                    </Grid>
                    <Grid size={{ xl: 1, lg: 2, sm: 2, xs: 12 }}></Grid>
                </Grid>
            </SCUIContent>
        </div>
    );
};
